"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoxString = void 0;
const utils_1 = require("./utils");
const internalRoxString = utils_1.internalRox.RoxString;
class RoxString extends internalRoxString {
}
exports.RoxString = RoxString;
//# sourceMappingURL=string.js.map